import { render, staticRenderFns } from "./AttachmentDetail.vue?vue&type=template&id=71a72001&"
import script from "./AttachmentDetail.vue?vue&type=script&lang=js&"
export * from "./AttachmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports